export const ROLLOUTS = {
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    LYNXES_TIKTOK_SHOP_SERVICE: 'lynxes_tiktok_shop_service',
    LYNXES_LOHP_REWORK: 'lynxes_lohp_rework',
    LYNXES_LOHP_INGRID: 'lynxes_lohp_ingrid',
    LYNXES_LOHP_INGRID_CACHE_WARMUP: 'lynxes_lohp_ingrid_cache_warmup',
};
